import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { SponsoringInstitution } from '@backrs_ui/grow-ui/src/redux/profile/profile';

type SnapshotDetails = Readonly<{
  location: string;
  gradeLabel?: string;
  major: string;
  sponsoringInstitutions: readonly SponsoringInstitution[];
}>;

export const useAgentContext = ({
  location,
  gradeLabel,
  major,
  sponsoringInstitutions,
}: SnapshotDetails) => {
  useRegisterAgentContext({
    kind: 'entity',
    description: "The details shown in the student's own profile snapshot.",
    data: {
      location: location || null,
      grade: gradeLabel || null,
      major: major || null,
      sponsoringInstitutions: sponsoringInstitutions.map(({ name }) => name),
    },
  });
};
